export const indianPhoneNoRegex = /^(\+91|\+91\-|0)?[6789]\d{9}$/

export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

export const numericKeysRegex = /^[0-9]$/

export const panCardRegex = /^[A-Z]{5}\d{4}[A-Z]$/